export function groupBy(array, key) {
    return array.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export function distinctBy(array, keySelector) {
    const seen = new Set();
    return array.filter(item => {
        const key = keySelector(item);
        if (seen.has(key)) {
            return false;
        } else {
            seen.add(key);
            return true;
        }
    });
}
